module.exports = "/HahaActive@2x-370c4e21e4c5c32b573daffbda02b706.png";